import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

type TReadProjectComment = {
    projectId: string;
};

export type TCommentProject = {
    Author: {
        id_e: string;
        name: string;
        avatar: string;
        Role: {
            id_e: string;
            name: string;
        };
    };
    project_id_e: string;
    created_at: string;
    id_e: string;
    id_i: number;
    text: string;
    updated_at: string;
    user_id_e: string;
    wasUpdated: boolean;
};

export type TReadProjectCommentResponse = {
    data: TCommentProject[];
};

export default async ({ projectId }: TReadProjectComment) => {
    const httpResponse = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/project/${projectId}/comment`,
        method: "get",
        headers: { auth: true },
    });
    const { body, statusCode } = httpResponse;

    return handleStatusCases<TReadProjectCommentResponse>({
        body,
        statusCode,
    });
};
